// extracted by mini-css-extract-plugin
export default {"root":"CustomInput_root__cEykW","input":"CustomInput_input__oY2kq"};